import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Message, SpinnerService } from 'shared-components';
import { DataProvider } from 'projects/packcert-web/src/app/providers/data.provider';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-confecciones-new-component',
    templateUrl: './new.component.html'
})
export class ConfeccionesNewComponent implements OnInit, OnDestroy {

    private readonly destroy$ = new Subject<void>();

    private _confeccionSimpleCaja;
    private _confeccionSimplePallet;
    private _confeccionCompleta;

    public newFormSimple: UntypedFormGroup;
    public newFormCompleta: UntypedFormGroup;

    public showError: boolean;
    public showWarning: boolean;
    public mensajes = new Array<Message>();

    public disabledDenominaciones: Subject<boolean> = new Subject();
    public disabledEtiquetador: Subject<boolean> = new Subject();
    public disabledUnidadMedida: Subject<boolean> = new Subject();
    public disabledForm: Subject<boolean> = new Subject();
    public disabledEnvases: Subject<boolean> = new Subject();

    public denominaciones;
    public denominacionesEnvases;
    public denominacionesPorciones = [];

    public envases;
    public envasesPorciones = [];
    public envasesPorcionesId = [];
    public envasesUsados = [];

    public porciones = [];

    public simpleModal = false;
    public resumenModal = false;

    public formVisible = 1;

    public resetDistribucion = false;

    public showCreate = true;

    public newPorciones = false;
    public newEnvases = false;

    public sumaKilos;
    public porcionesEnvase;

    public idTabla = 1;

    public lsCajas = [];
    public lsEnvases = [];
    public lsPorciones = [];

    public disabledButtonInsertar = false;
    public disabledButtonAvanzada = false;

    public showSiguiente = false;

    public numCajas = 1;

    public tipoConfeccionList = [
        {
            id: 1,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.caja')
        },
        {
            id: 2,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.tipos.pallet')
        }
    ];

    public unidadesMedidaList = [
        {
            id: 1,
            des: this._translate.instant('mantenimientoConfecciones.confeccion.unidades.kilogramos')
        }
    ];

    @Input() tipoConfeccion: number;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<Message>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _translate: TranslateService,
        private readonly _sessionContext: SessionContextService
    ) { }

    ngOnInit() {
        this.newFormSimple = this._fb.group({
            des: ['', Validators.required],
            alias: [''],
            etiquetador: ['', Validators.required],
            denominacion: [{ value: '', disabled: true }, Validators.required],
            tipoConfeccion: [{ value: this.tipoConfeccionList.find(x => x.id === this.tipoConfeccion), disabled: true }, Validators.required],
            numCajas: [1],
            unidadMedida: ['', Validators.required],
            kilos: ['', Validators.required],
            envase: [{ value: '', disabled: true }],
            pesoEnvase: [{ value: '', disabled: true }],
            numeroEnvasesCaja: [{ value: '', disabled: true }]
        });

        this.newFormSimple.get('etiquetador').valueChanges
            //.pipe(debounceTime(500))
            .pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)))
            .pipe(takeUntil(this.destroy$))
            .subscribe((etiquetador) => {
                if (etiquetador) {
                    let _filters = {
                        etiquetadorId: etiquetador.id
                    };
                    this._spinnerService.showSpinner();
                    this._etiquetadoService.getDenominaciones(_filters).toPromise().finally(() => {
                        this._spinnerService.hideSpinner();
                    }).then((resp) => {
                        if (resp.lista.length > 0) {
                            this.denominaciones = resp.lista;
                            this.denominacionesEnvases = resp.lista;
                            this.disabledDenominaciones.next(false);
                            this.newFormSimple.get('denominacion').enable();

                            if (this.denominaciones.length === 1) {
                                this.newFormSimple.get('denominacion').patchValue(this.denominaciones[0]);
                                this.newFormSimple.get('denominacion').disable();
                                this.disabledDenominaciones.next(true);
                            } else {
                                if (this.newFormSimple.get('tipoConfeccion').value.id === 1) {
                                    this.denominaciones.push({
                                        id: null,
                                        des: 'Mix'
                                    });
                                }
                            }
                        }
                    });
                    let _filterEnvases = {
                        etiquetadorId: etiquetador.id,
                        creadoAuto: false
                    };
                    this._etiquetadoService.getEnvases(_filterEnvases).toPromise().finally(() => {
                        this._spinnerService.hideSpinner();
                    }).then((resp) => {
                        if (resp.lista.length > 0) {
                            this.envases = resp.lista;
                            this.disabledEnvases.next(false);
                            this.newFormSimple.get('envase').enable();
                        }
                    });
                } else {
                    this.denominaciones = null;
                    this.envases = null;
                    this.disabledDenominaciones.next(true);
                    this.disabledEnvases.next(true);
                    this.newFormSimple.get('denominacion').reset();
                    this.newFormSimple.get('envase').reset();
                }
            });

        this.newFormSimple.get('envase').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((envase) => {
            if (envase) {
                this.newFormSimple.get('pesoEnvase').patchValue(envase.kilos);
                if (this.newFormSimple.get('kilos').value) {
                    this.newFormSimple.get('numeroEnvasesCaja').patchValue(this.getNumeroEnvasesCaja());
                }
            } else {
                this.newFormSimple.get('pesoEnvase').patchValue('');
                this.newFormSimple.get('numeroEnvasesCaja').patchValue('');
            }
        });

        this.newFormSimple.get('kilos').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((pesoCaja) => {
            if (pesoCaja) {
                if (this.newFormSimple.get('envase').value) {
                    this.newFormSimple.get('numeroEnvasesCaja').patchValue(this.getNumeroEnvasesCaja());
                }
            }
        });

        this.newFormSimple.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion) {
                denominacion.des === 'Mix' ? this.disabledButtonInsertar = true : this.disabledButtonInsertar = false;
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public get etiquetadores() {
        if (this._dataProvider.etiquetadores.length === 1) {
            this.newFormSimple.get('etiquetador').patchValue(this._dataProvider.etiquetadores[0]);
            this.newFormSimple.get('etiquetador').disable({ onlySelf: true, emitEvent: false });
            this.disabledEtiquetador.next(true);
        } else {
            this.newFormSimple.get('etiquetador').enable({ onlySelf: true, emitEvent: false });
            this.disabledEtiquetador.next(false);
        }
        return this._dataProvider.etiquetadores;
    }

    public get tiposConfeccion() {
        return this.tipoConfeccionList;
    }

    public get unidadesMedida() {
        if (this.unidadesMedidaList.length === 1) {
            this.newFormSimple.get('unidadMedida').patchValue(this.unidadesMedidaList[0]);
            this.newFormSimple.get('unidadMedida').disable({ onlySelf: true, emitEvent: false });
        } else {
            this.newFormSimple.get('unidadMedida').enable({ onlySelf: true, emitEvent: false });
            this.disabledUnidadMedida.next(false);
        }
        return this.unidadesMedidaList;
    }

    public close() {
        this.refresh.emit(false);
    }

    public addSimple() {
        this.simpleModal = false;
        this.checkFormSimple();
        if (this.newFormSimple.valid) {
            if (this.newFormSimple.get('tipoConfeccion').value.id === 1) {
                this._confeccionSimpleCaja = {
                    des: this.newFormSimple.get('des').value ? this.newFormSimple.get('des').value : '',
                    alias: this.newFormSimple.get('alias').value ? this.newFormSimple.get('alias').value : '',
                    etiquetadorId: this.newFormSimple.get('etiquetador').value ? this.newFormSimple.get('etiquetador').value.id : '',
                    denominacionId: this.newFormSimple.get('denominacion').value ? this.newFormSimple.get('denominacion').value.id : '',
                    tipoConfeccionId: this.newFormSimple.get('tipoConfeccion').value ? this.newFormSimple.get('tipoConfeccion').value.id : '',
                    unidadMedidaId: this.newFormSimple.get('unidadMedida').value ? this.newFormSimple.get('unidadMedida').value.id : '',
                    kilos: this.newFormSimple.get('kilos').value ? this.newFormSimple.get('kilos').value : '',
                    envaseIdUnico_Info: this.newFormSimple.get('envase').value ? this.newFormSimple.get('envase').value.id : null
                };
                this._spinnerService.showSpinner();
                this._etiquetadoService.createConfeccionSimpleCaja(this._confeccionSimpleCaja).toPromise().finally(() => {
                    this._spinnerService.hideSpinner();
                }).then(
                    (resp) => {
                        this.refresh.emit(true);
                        this.mensaje.emit({ class: 'success', message: 'global.success.itemUpdated' });
                    },
                    (error) => {
                        this.showError = true;
                        let mensaje;
                        if (error.status === 420) {
                            switch (error.error.ApiErrorCode) {
                                case 6165: //ConfeccionYaExiste
                                    mensaje = this._translate.instant('ApiErrors.confeccionYaExiste');
                                    break;
                                default:
                                    mensaje = this._translate.instant('ApiErrors.serverError');
                                    break;
                            }
                        } else {
                            mensaje = this._translate.instant('ApiErrors.serverError');
                        }
                        this.mensajes.push({ class: 'error', message: mensaje });
                    }
                );
            }
        }
    }

    public addCompleta() {
        this.checkFormCompleta();
        if (this.newFormCompleta.valid && this.checkDisenyoPorciones(this.porciones) && this.checkPesoEnvase(this.porciones)) {
            this._confeccionCompleta = {
                des: this.newFormCompleta.get('des').value ? this.newFormCompleta.get('des').value : '',
                alias: this.newFormCompleta.get('alias').value ? this.newFormCompleta.get('alias').value : '',
                etiquetadorId: this.newFormCompleta.get('etiquetador').value ? this.newFormCompleta.get('etiquetador').value.id : '',
                denominacionId: this.newFormCompleta.get('denominacion').value ? this.newFormCompleta.get('denominacion').value.id : '',
                tipoConfeccionId: this.newFormCompleta.get('tipoConfeccion').value ? this.newFormCompleta.get('tipoConfeccion').value.id : '',
                unidadMedidaId: this.newFormCompleta.get('unidadMedida').value ? this.newFormCompleta.get('unidadMedida').value.id : '',
                lsCajas: [
                    {
                        des: this.newFormCompleta.get('des').value ? this.newFormCompleta.get('des').value : '',
                        numCajas: this.numCajas,
                        lsEnvases: this.getEnvasesPorciones()
                    }
                ]
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.createConfeccionCompletaCaja(this._confeccionCompleta).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.refresh.emit(true);
                    this.mensaje.emit({ class: 'success', message: 'global.success.itemUpdated' });
                },
                (error) => {
                    this.showError = true;
                    let message;
                    if (error.status === 420) {
                        switch (error.error.ApiErrorCode) {
                            case 6165: //ConfeccionYaExiste
                                message = this._translate.instant('ApiErrors.confeccionYaExiste');
                                break;
                            default:
                                message = this._translate.instant('ApiErrors.serverError');
                                break;
                        }
                    } else {
                        message = this._translate.instant('ApiErrors.serverError');
                    }
                    this.mensajes.push({ class: 'error', message: message });
                }
            );
        }
    }

    private getEnvasesPorciones() {
        this.lsEnvases = [];
        let lsEnvase;
        for (let envasePorciones of this.envasesPorciones) {
            if (envasePorciones.cantidad > 1) {
                for (let i = 0; i < envasePorciones.cantidad; i++) {
                    lsEnvase = {
                        envaseId: envasePorciones.id,
                        lsPorciones: this.porciones.length > 0 ? this.porciones.filter(x => x.envaseIdTabla === envasePorciones.idTabla) : [
                            {
                                denominacionId: this.newFormCompleta.get('denominacion').value.id,
                                kilos: envasePorciones.peso,
                                porcionesEnEnvase: 1
                            }
                        ]
                    };
                    this.lsEnvases.push(lsEnvase);
                }
            } else {
                lsEnvase = {
                    envaseId: envasePorciones.id,
                    lsPorciones: this.porciones.length > 0 ? this.porciones.filter(x => x.envaseIdTabla === envasePorciones.idTabla) : [
                        {
                            denominacionId: this.newFormCompleta.get('denominacion').value.id,
                            kilos: envasePorciones.peso,
                            porcionesEnEnvase: 1
                        }
                    ]
                };
                this.lsEnvases.push(lsEnvase);
            }
        }
        return this.lsEnvases;
    }

    public getCajas() {
        this.lsCajas = [];
        for (let i = 0; i < this.numCajas; i++) {
            let caja = {
                des: this.newFormCompleta.get('des').value ? this.newFormCompleta.get('des').value : '',
                numCajas: this.numCajas,
                lsEnvases: this.getEnvasesPorciones()
            };
            this.lsCajas.push(caja);
        }
        return this.lsCajas;
    }

    private checkDisenyoPorciones(porciones) {
        if (porciones.every(x => x.disenyoEtiquetasIdCaja === porciones[0].disenyoEtiquetasIdCaja)) {
            return true;
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.error.errorEtiquetaCaja' });
            return false;
        }
    }

    private checkPesoEnvase(porciones) {
        let sumaPesos = 0;
        if (this.porciones.length > 0) {
            for (let envase of this.envasesPorciones) {
                let porcionesPeso = porciones.filter(x => x.envaseIdTabla === envase.idTabla);
                for (let porcion of porcionesPeso) {
                    sumaPesos += porcion.kilos;
                }
                if (sumaPesos < envase.peso) {
                    this.showError = true;
                    this.mensajes.push({ class: 'error', message: this._translate.instant('mantenimientoConfecciones.error.pesoNoSuperado.parte1') + ' ' + envase.des + ' ' + this._translate.instant('mantenimientoConfecciones.error.pesoNoSuperado.parte2') });
                    return false;
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    public changeForm() {
        this.showSiguiente = false;
        this.simpleModal = false;
        this.formVisible = 2;
        this.numCajas = this.newFormSimple.get('numCajas').value;
        this.disabledForm.next(true);
        this.newFormCompleta = this._fb.group({
            des: [this.newFormSimple.get('des').value, Validators.required],
            alias: [this.newFormSimple.get('alias').value],
            etiquetador: [{ value: this.etiquetadores.find(x => x.id === this.newFormSimple.get('etiquetador').value.id), disabled: true }
                , Validators.required],
            denominacion: [{
                value: this.denominaciones.find(x => x.id === this.newFormSimple.get('denominacion').value.id)
                , disabled: true
            }
                , Validators.required],
            tipoConfeccion: [{
                value: this.tiposConfeccion.find(x => x.id === this.newFormSimple.get('tipoConfeccion').value.id)
                , disabled: true
            }
                , Validators.required],
            numCajas: [{ value: this.newFormSimple.get('numCajas').value, disabled: false }],
            unidadMedida: [{ value: this.unidadesMedida.find(x => x.id === this.newFormSimple.get('unidadMedida').value.id), disabled: true }
                , Validators.required],
            kilos: [this.newFormSimple.get('kilos').value, Validators.required],
            pesoPallet: [{ value: this.newFormSimple.get('kilos').value * this.numCajas, disabled: true }, Validators.required],
            envase: [{ value: this.newFormSimple.get('envase').value, disabled: true }],
            numeroEnvasesCaja: [{ value: this.newFormSimple.get('numeroEnvasesCaja').value, disabled: true }]
        });

        if (this.newFormSimple.get('envase').value) {
            this.envasesPorciones.push({
                idTabla: this.idTabla,
                id: this.newFormSimple.get('envase').value.id,
                des: this.newFormSimple.get('envase').value.des,
                peso: this.newFormSimple.get('envase').value.kilos,
                cantidad: this.newFormSimple.get('numeroEnvasesCaja').value
            });
            this.idTabla++;
            this.transformEnvasesId();
        }

        if (this.newFormSimple.get('denominacion').value.des === 'Mix') {
            this.showWarning = true;
            this.mensajes.push({ class: 'warning', message: 'mantenimientoConfecciones.error.obligatorioDenominaciones' });
        }

        this.newFormCompleta.get('denominacion').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((denominacion) => {
            if (denominacion.des === 'Mix' && this.porciones.length === 0) {
                this.showWarning = true;
                this.mensajes.push({ class: 'warning', message: 'mantenimientoConfecciones.error.obligatorioDenominaciones' });
            }
        });

        this.newFormCompleta.get('numCajas').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((numCajas) => {
            if (numCajas) {
                this.numCajas = Number(numCajas);
                this.newFormCompleta.get('pesoPallet').patchValue(this.newFormCompleta.get('kilos').value * this.numCajas);
            }
        });

    }

    private checkFormSimple() {
        this.showError = this.newFormSimple.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    private checkFormCompleta() {
        this.showError = this.newFormCompleta.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }

    private checkPesoCajayEnvasesCaja() {
        let pesoCaja = 0;
        let envasesCaja = 0;
        this.envasesPorciones.forEach(envasePorciones => {
            pesoCaja = pesoCaja + (envasePorciones.peso * envasePorciones.cantidad);
            envasesCaja = envasesCaja + envasePorciones.cantidad;
        });
        this.newFormCompleta.get('kilos').patchValue(pesoCaja);
        this.newFormCompleta.get('numeroEnvasesCaja').patchValue(envasesCaja);
        this.newFormCompleta.get('pesoPallet').patchValue(this.newFormCompleta.get('kilos').value * this.numCajas);
    }

    public addNewEnvases() {
        this.newEnvases = true;
    }

    private transformEnvasesId() {
        this.envasesPorcionesId = this.envasesPorciones.map(envase => ({
            idTabla: envase.idTabla,
            id: envase.id,
            des:'ID: ' + envase.idTabla + ', Envase: ' + envase.des,
            peso: envase.peso,
            cantidad: envase.cantidad
        }));
    }


    public refreshAddEnvases(envase) {
        if (envase) {
            this.envasesPorciones.push(envase);
            this.idTabla++;
            this.newEnvases = false;

            if (this.envasesPorciones.length > 1) {
                this.newFormCompleta.get('envase').patchValue({ id: -1, des: this._translate.instant('global.varios') })
            } else if (this.envasesPorciones.length === 0) {
                this.newFormCompleta.get('envase').patchValue('');
            } else {
                this.newFormCompleta.get('envase').patchValue(this.envasesPorciones[0]);
            }

            this.checkPesoCajayEnvasesCaja();
            this.transformEnvasesId();
        }
    }

    public refreshRemoveEnvases(envase) {
        const index = this.envasesPorciones.indexOf(envase);
        if (index > -1) {
            this.removePorcionesEnvase(envase);
            this.envasesPorciones.splice(index, 1);

            if (this.envasesPorciones.length > 1) {
                this.newFormCompleta.get('envase').patchValue({ id: -1, des: this._translate.instant('global.varios') })
            } else if (this.envasesPorciones.length === 0) {
                this.newFormCompleta.get('envase').patchValue('');
            } else {
                this.newFormCompleta.get('envase').patchValue(this.envasesPorciones[0]);
            }

            this.checkPesoCajayEnvasesCaja();

            if (this.envasesPorciones.length > 0) {
                this.envasesPorciones.forEach((envasePorcion, index) => {
                    envasePorcion.idTabla = index + 1;
                    this.idTabla = index + 1;
                });
                this.idTabla++;
            } else {
                this.idTabla = 1;
            }

            this.transformEnvasesId();
        }
    }

    public removePorcionesEnvase(envase) {
        if (this.porciones.filter(x => x.desEnvase === envase.des)) {
            const porcionesRemove = this.porciones.filter(x => x.desEnvase === envase.des);
            for (let porcionRemove of porcionesRemove) {
                const index = this.porciones.indexOf(porcionRemove);
                if (index > -1) {
                    this.porciones.splice(index, 1);
                }
            }
        }
    }

    public addNewPorciones() {
        this.newPorciones = true;
    }

    public refreshAddPorcionesEnvase(porcion) {
        if (porcion) {
            this.porciones.push(porcion);
            this.newPorciones = false;
            
            if (this.porciones.length > 1) {
                this.porciones.forEach(porcionArray => {
                    if (porcionArray.denominacionId !== this.porciones[0].denominacionId) {
                        this.newFormCompleta.get('denominacion').patchValue(this.denominaciones[this.denominaciones.length-1]);
                    } else {
                        this.newFormCompleta.get('denominacion').patchValue(this.denominaciones.find(x => x.id === porcionArray.denominacionId));
                    }
                });
            } else if (this.porciones.length === 1) {
                this.newFormCompleta.get('denominacion').patchValue(this.denominaciones.find(x => x.id === this.porciones[0].denominacionId))
            } else {
                this.newFormCompleta.get('denominacion').patchValue('');
            }
        } else {
            this.showError = true;
            if (this.showError === true) {
                this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.duplicarConfecciones.error.superaLimiteEnvases' });
            }
        }

        this.porciones.length > 0 ? this.disabledButtonInsertar = false : this.disabledButtonInsertar = true;
    }

    public refreshRemovePorcionesEnvase(porcion) {
        const index = this.porciones.indexOf(porcion);
        if (index > -1) {
            this.porciones.splice(index, 1);

            if (this.porciones.length > 1) {
                this.porciones.forEach(porcion => {
                    if (porcion.denominacionId !== this.porciones[0].denominacionId) {
                        this.newFormCompleta.get('denominacion').patchValue(this.denominaciones[this.denominaciones.length-1]);
                    } else {
                        this.newFormCompleta.get('denominacion').patchValue(this.denominaciones.find(x => x.id === porcion.denominacionId));
                    }
                });
            } else if (this.porciones.length === 1) {
                this.newFormCompleta.get('denominacion').patchValue(this.denominaciones.find(x => x.id === this.porciones[0].denominacionId));
            } else {
                this.newFormCompleta.get('denominacion').patchValue('');
            }
        }

        this.porciones.length > 0 ? this.disabledButtonInsertar = false : this.disabledButtonInsertar = true;
    }

    public changeSiguiente() {
        this.checkFormSimple();
        if (this.newFormSimple.valid) {
            this.changeForm();
        }
    }

    /**
     * Ir a Configuración Avanzada
     */
    public showSimpleModal() {
        this.checkFormSimple();
        if (this.newFormSimple.valid && this.envases && this.envases.length > 0) {
            this.simpleModal = true;
        } else {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.error.configAvanzada' });
        }
    }

    private getNumeroEnvasesCaja(): number {
        let envasesCaja = this.newFormSimple.get('kilos').value / this.newFormSimple.get('pesoEnvase').value;

        if (envasesCaja - Math.floor(envasesCaja) !== 0) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.error.envasePeso' });
            this.disabledButtonInsertar = true;
            this.disabledButtonAvanzada = true;
            return 0;
        } else if (envasesCaja > 50) {
            this.showError = true;
            this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.error.limiteCantidad' });
            this.disabledButtonInsertar = true;
            this.disabledButtonAvanzada = true;
        } else {
            this.showError = false;
            this.disabledButtonInsertar = false;
            this.disabledButtonAvanzada = false;
            this.newFormSimple.get('denominacion').value.des === 'Mix' ? this.disabledButtonInsertar = true : this.disabledButtonInsertar = false;
            return envasesCaja;
        }
    }

}
